






















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Rectangle } from "../../domain/drawing";
import { DragHandleMixin } from "./mixins";

@Component({
})
export default class MoveDragHandleArea extends Mixins(DragHandleMixin) {
  @Prop()
  rectangle: Rectangle;

  @Prop({ default: false })
  isFrameOnly: boolean;

  get locationStyle(): any {
    return {
      left: this.rectangle.x + "px",
      top: this.rectangle.y + "px",
    };
  }

  get width(): number {
    return this.rectangle.width;
  }

  get height(): number {
    return this.rectangle.height;
  }

  get pointerStyle(): any {
    return {
      pointerEvents: this.isFrameOnly ? "visiblestroke" : "visiblepainted",
    };
  }

  @Emit()
  click(event: PointerEvent): void {}

  @Emit()
  dblclick(event: PointerEvent): void {}

  @Emit()
  clickPrevented(event: PointerEvent): void {}

  @Emit()
  dblclickPrevented(event: PointerEvent): void {}
}
